import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export const useConfirm = () => {
  const [promise, setPromise] = React.useState(null);

  const confirm = (title, message) =>
    new Promise((resolve) => {
      setPromise({ resolve, title, message });
    });

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  const ConfirmDialog = () => (
    <AlertDialog open={promise !== null} onOpenChange={handleClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-semibold text-[#C9A961]">
            {promise?.title || 'Confirmar'}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[#2C2C2C] text-base">
            {promise?.message || '¿Estás seguro?'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel} className="border-[#C9A961]/30">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} className="bg-[#C9A961] hover:bg-[#B89551]">
            Confirmar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { confirm, ConfirmDialog };
};
